import type { ApiErrorBody, AttachmentDTO } from "@justone/shared";
import { ApiError } from "./http";

/** 첨부 올리기 (진행률을 받으려고 fetch 대신 XHR) */
export function uploadAttachment(file: File, onProgress: (ratio: number) => void): { promise: Promise<AttachmentDTO>; abort: () => void } {
  const xhr = new XMLHttpRequest();
  const promise = new Promise<AttachmentDTO>((resolve, reject) => {
    xhr.open("POST", "/api/attachments");
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress(e.loaded / e.total);
    xhr.onload = () => {
      let data: unknown;
      try {
        data = JSON.parse(xhr.responseText);
      } catch {
        data = undefined;
      }
      if (xhr.status >= 200 && xhr.status < 300) return resolve(data as AttachmentDTO);
      const err = (data as ApiErrorBody | undefined)?.error;
      reject(new ApiError(xhr.status, err?.code ?? "upload_failed", err?.message ?? `올리지 못했습니다 (${xhr.status}).`));
    };
    xhr.onerror = () => reject(new ApiError(0, "network", "서버에 연결할 수 없습니다."));
    xhr.onabort = () => reject(new ApiError(0, "aborted", "취소했습니다."));
    const form = new FormData();
    form.append("file", file, file.name);
    xhr.send(form);
  });
  return { promise, abort: () => xhr.abort() };
}
